import { getNetworkDetailV2, getNetworkDetailV3 } from 'services';
import { Toast } from 'antd-mobile';

import lgText from '../../../config/language';
import getHideLoungeArr from 'utils/hideLoungeData';
import { getAgentId } from 'utils/getValue';
import getSortLoungeData from '@/utils/sortLoungeData';
let loungeType = {
  lounge: lgText['休息室'],
  restaurant: lgText['餐食体验厅'],
  spa: lgText['SPA'],
};
const specialLoungeType = {
  122: {
    lounge: lgText['贵宾休息室'],
  },
  12002: {
    lounge: lgText['贵宾休息室'],
  },
};
const limits = {
  lounge: [
    { name: lgText['航站楼'], type: 'terminal' },
    { name: lgText['安检类型'], type: 'inspection' },
    { name: lgText['筛选'], type: 'all' },
  ],
  restaurant: [
    { name: lgText['安检类型'], type: 'inspection' },
    { name: lgText['筛选'], type: 'all' },
  ],
  spa: [
    { name: lgText['安检类型'], type: 'inspection' },
    { name: lgText['筛选'], type: 'all' },
  ],
};

function onDelItemName(list) {
  const delItemNames = ['睡大觉', '睡大觉！', '睡大觉!'];
  const arr = [...list];
  arr.forEach((el) => {
    if (el.itemNameList && el.itemNameList.length > 0) {
      el.itemNameList.forEach((item, idx) => {
        if (delItemNames.includes(item)) {
          console.log('111', el);
          el.itemNameList.splice(idx, 1);
        }
      });
    }
  });
  return arr;
}

export default {
  namespace: 'airport',
  state: {
    limitData: limits, // 休息室类型下面的限制选择，做视图展示以及接口参数
    tagList: [], // 标签列表
    tagIdx: 1,
    loungeData: {}, // 休息室的数据 用来展示页面
    loungeActKey: null, // 当前休息室类型  页面顶部休息室选择项
    selectScreen: {}, // 选中的筛选项，以机场id以及休息室类型划分，比如  {lounge:{inspection:安检后}}
    showMoreScreen: {}, //  展开更多条件 以筛选项做划分  比如 {lounge:{inspection:true}}
  },
  effects: {
    *queryNetworkDetail({ payload }, { call, put, select }) {
      Toast.loading('Loading...');
      const isInit = payload.isInit;
      const onlyShowType = payload.onlyShowType;
      if (onlyShowType) delete payload.onlyShowType;
      delete payload.isInit;
      // 20241010 文斌需求，判断url是否有三字码，有就用v3接口
      const uri = payload.iataCode ? getNetworkDetailV3 : getNetworkDetailV2;
      const response = yield call(uri, payload);
      const { state, data = {} } = response.data;
      const setData = {};
      if (state === '11') {
        const nav = Object.keys(data); // 顶部休息室类型  20230201 创哥说没有其他类型所以前端先写死休息室和餐食体验厅
        // 20241025 要求中信OTA休息室叫贵宾休息室
        const specialLoungeTypeKey = Object.keys(specialLoungeType);
        const agentId = getAgentId();
        const isSpecial = specialLoungeTypeKey.includes(agentId);
        if (isSpecial) {
          const specialKeyInfo = specialLoungeType[agentId];
          loungeType = {
            ...loungeType,
            ...specialKeyInfo,
          };
        }

        // 顶部导航栏添加中文名字   以后可能添加其他类型，所以为了方便统一这里处理了,类型多起来需要喊接口给中文名增加性能
        nav.map((el) => {
          // 20230216 创哥说目前只有普通休息室和餐食体验厅,spa，所以只写死这两个
          if (!loungeType[el]) return;
          data[el].navName = loungeType[el];
          // 对筛选内容排序
          let { screen, list = [], noList = [] } = data[el];
          // 20241010 弟哥要求增加url参数ttype，意思是只展示某一个休息室类型，比如只展示普通休息室
          if (onlyShowType && onlyShowType !== el) {
            list = [];
          }
          const hasData = list.length !== 0 || noList.length !== 0;
          // 如果第一次请求，赋值 loungeActKey
          if (isInit && hasData && !setData.loungeActKey) {
            setData.loungeActKey = el;
          }
          if (!hasData) {
            return delete data[el];
          }
          // 如果筛选条件返回null了，先删除
          for (const key in screen) {
            const element = screen[key];
            if (!element) delete screen[key];
          }
          const screenList = Object.values(screen).sort((a, b) => a.sort - b.sort);
          data[el].screenList = screenList;

          // 注意 20230428 卢军志 要 求指定的网点隐藏不展示
          try {
            const hideLounges = getHideLoungeArr();
            if (hideLounges.length !== 0) {
              const newList = [];
              const listKey = list.length > 0 ? 'list' : 'noList';
              const loungeList = list.length > 0 ? list : noList;
              loungeList.forEach((el) => {
                const isHide = hideLounges.includes(el.code);
                if (!isHide) {
                  newList.push(el);
                }
              });
              data[el][listKey] = newList;
            }
          } catch (error) {
            console.log('计算隐藏特殊网点报错', error);
          }
          // 注意 20250312 秦蓉要求给指定休息室排序
          try {
            const sortLoungeData = getSortLoungeData();
            if (sortLoungeData && data[el].list.length > 1) {
              const sortList = [...data[el].list];
              sortList.forEach((el) => {
                const code = el.code;
                if (sortLoungeData[code]) {
                  el.specialSort = sortLoungeData[code];
                } else {
                  el.specialSort = 1;
                }
              });
              data[el].list = sortList.sort((a, b) => b.specialSort - a.specialSort);
            }
          } catch (error) {
            console.log('排序特殊网点报错', error);
          }
          // 20250314，出现了标签睡大觉！ 目前数据源没找到问题，前端特殊处理

          try {
            list = onDelItemName(list);
            noList = onDelItemName(noList);
          } catch (error) {}
        });

        if (isInit) {
          let limiFilter = {}; // 筛选limit
          Object.keys(data).forEach((item) => {
            // 外部的筛选tab是写死的，把赛选条件不存在的过滤掉，通过接口的screen里控制； //202302 2/28优化
            if (!limits[item]) return;
            limiFilter[item] = limits[item].filter((searchTab) => {
              const screen = data[item]['screen'];
              return !!screen[searchTab.type + 's'] || searchTab.type === 'all';
            });
          });
          setData.limitData = limiFilter;
        }
        yield put({
          type: 'setData',
          payload: {
            ...setData,
            loungeData: data,
          },
        });
        Toast.hide();
      }
    },
  },
  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
